import { useCollectionItem, useLiveQuery } from '@rocketlane/state-db';
import { useEffect } from 'react';
import { MemberType } from 'api/models';
import { fetchAllTeams } from './fetchers';
import { teamsCollection } from './teams-collection';
export const useTeams = ()=>useLiveQuery(teamsCollection, (all)=>all, []);
export const useTeam = (teamId)=>useCollectionItem(teamsCollection, teamId);
export const useAllTeamsInAccountFromCollection = ()=>{
    useEffect(()=>{
        if (teamsCollection.getAll().length === 0) {
            fetchAllTeams().catch(()=>{});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return useLiveQuery(teamsCollection, (all)=>all, []);
};
export const useNativeTeamsFromCollection = ()=>useLiveQuery(teamsCollection, (all)=>all.filter((t)=>t.teamType !== MemberType.External).map(({ userList: _u, companyList: _c, ...rest })=>rest), []);
export const useDefaultTeamsFromCollection = ()=>useLiveQuery(teamsCollection, (all)=>all.filter((t)=>!t.projectId), []);
export const useProjectTeamsFromCollection = (projectId)=>useLiveQuery(teamsCollection, (all)=>all.filter((t)=>t.projectId === projectId), [
        projectId
    ]);
